import React, { useState, useEffect } from "react";
import moment from "moment-jalaali";
import "./support.css";

export default function Support() {
  const [messages, setMessages] = useState([]);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);

  const fetchMessages = async () => {
    try {
      const response = await fetch("http://185.164.73.170:5001/api/messages");
      const data = await response.json();
      setMessages(data);
    } catch (error) {
      console.error("خطا در دریافت پیام‌ها", error);
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 20000);
    return () => clearInterval(interval);
  }, []);

  const handleRegister = () => {
    if (name.trim()) {
      setIsRegistered(true);
      localStorage.setItem('supportname', name);
    }
  };

  const handleSendMessage = async () => {
    if (message.trim()) {
      const date = moment().format("jYYYY/jMM/jDD");
      const time = moment().format("HH:mm:ss");

      const newMessage = { name, message, date, time };

      try {
        await fetch("http://185.164.73.170:5001/api/messages", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newMessage),
        });
        setMessage("");
        fetchMessages();
      } catch (error) {
        console.error("خطا در ارسال پیام", error);
      }
    }
  };

  return (
    <div className="chat-container">
      {!isRegistered && !localStorage.getItem('supportname') ? (
        <div className="register">
          <h2>ثبت نام</h2>
          <input
            type="text"
            placeholder="نام خود را وارد کنید"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <button onClick={handleRegister}>ثبت نام</button>
        </div>
      ) : (
        <div className="chat-box">
          <div className="messages">
            {messages.map((msg, index) => (
              <div key={index} className="message">
                <div className="message-header">
                  <span className="username">{msg.name}</span>
                  <span className="timestamp">{msg.date} - {msg.time}</span>
                </div>
                <div className="message-text">{msg.message}</div>
              </div>
            ))}
          </div>
          <div className="send-message">
            <input
              type="text"
              placeholder="پیام خود را بنویسید"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button onClick={handleSendMessage}>ارسال</button>
          </div>
        </div>
      )}
    </div>
  );
            }